import { render, staticRenderFns } from "./EmployeeGroupPageTable.vue?vue&type=template&id=bed266fc&scoped=true&"
import script from "./EmployeeGroupPageTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed266fc",
  null
  
)

export default component.exports